import React from 'react';
// import { CaseCoverageDiv } from './Details.styled';
import {
    AccountFieldTitle,
    AccountFieldAddress,
    LineSeparator,
    OptionContainer,
    OptionAccountContainer,
    OptionCoverageContainer,
    OuterContainer,
    DefaultContainer,
} from './shipToTemplate.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import ChipComponent from 'src/common/refactoredComponents/chipComponent';

export default function ShipToTemplate({
    option,
    fieldname,
    value,
    nameWidth,
    isDefault,
}) {
    const trimmedShippingAddressId = accountNumberZeroTrimmer(
        option.shippingAddressId
    );
    return (
        <>
            <OuterContainer margin display="unset">
                <div style={{ display: 'block' }}>
                    <>
                        <OptionContainer padding={'10px 10px 5px 10px'}>
                            <OptionAccountContainer>
                                <DefaultContainer>
                                    <div>
                                        {' '}
                                        <AccountFieldTitle
                                            width={
                                                nameWidth ? nameWidth : '70%'
                                            }
                                            mobileWidth={
                                                nameWidth ? nameWidth : '70%'
                                            }
                                            iPadwidth={
                                                nameWidth ? nameWidth : '70%'
                                            }
                                        >
                                            {option?.accountName}
                                            {/* {option.accountName ||

`${option?.physicianFirstName} ${option?.physicianLastName}` ||

`${option.physicianDisplayName}`}{' '} */}
                                        </AccountFieldTitle>
                                        <AccountFieldTitle
                                            margin="0px 5px"
                                            fontFamily="AvenirNextWorld Italic"
                                        >
                                            {trimmedShippingAddressId}
                                        </AccountFieldTitle>
                                        <br />
                                        <AccountFieldAddress>
                                            {option.addressLine1}
                                        </AccountFieldAddress>
                                    </div>
                                    {option?.defaultAddress && (
                                        <ChipComponent
                                            height={'auto'}
                                            label="Default"
                                            color="#4f4f4f"
                                            borderRadius="6px"
                                            isFromAutoComplete={true}
                                            desktopPadding={'5px'}
                                            style={{
                                                marginLeft: '2ch',
                                                maxWidth: 'calc(100% - 40px)',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        />
                                    )}
                                </DefaultContainer>
                                {/* <div>
                                    <AccountFieldAddress>
                                        {option.addressLine1}
                                    </AccountFieldAddress>
                                </div> */}
                                <div>
                                    <AccountFieldAddress>
                                        {option.city}
                                        {option.city && <>,&nbsp;</>}
                                    </AccountFieldAddress>
                                    <AccountFieldAddress>
                                        {option.region}
                                        {(option.city || option.region) &&
                                            option.postalCode && <>,&nbsp;</>}
                                    </AccountFieldAddress>
                                    <AccountFieldAddress>
                                        {option.postalCode}
                                    </AccountFieldAddress>
                                </div>
                            </OptionAccountContainer>
                        </OptionContainer>
                    </>
                    <LineSeparator></LineSeparator>
                </div>
            </OuterContainer>
        </>
    );
}
